import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/entities/branches',
    name: RouteName.Branches,
    component: () => import('@/pages/Branches/Branches'),
    meta: {
      breadcrumb: {
        label: 'Филиалы',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/entities/branches/create',
    name: 'filialCreate',
    component: () => import('@/pages/Branches/BranchesCreate'),
    meta: {
      breadcrumb: {
        label: 'Новый филиал',
        parent: RouteName.Branches,
      },
    },
  },
  {
    path: '/entities/branches/:id',
    name: 'filialEdit',
    component: () => import('@/pages/Branches/BranchesSingle'),
    props: { isEdit: false },
    meta: {
      breadcrumb: {
        label: 'Редактирование филиала',
        parent: RouteName.Branches,
      },
    },
  },
]
